import { render, staticRenderFns } from "./Funcionarios.vue?vue&type=template&id=81332aa8"
import script from "./Funcionarios.vue?vue&type=script&lang=js"
export * from "./Funcionarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports